(ns minorodata.tables-metadata.model
  (:require [mold.core :as m :include-macros true]))

(declare ->tables-metadata)

(m/defmodel tables-metadata
  {:tables   [::m/vector ::m/nilable "List of alternative tables"]
   :query    [::m/string ::m/nilable "Query to search"]
   :fields   [::m/vector ::m/nilable "Fields to display"]
   :catalogs [::m/vector ::m/nilable "List of catalogs with schemas"]}

  {:singleton true})
